import { defineStore } from "pinia";
import { markRaw } from "vue";

import {
  api,
  type QueryParams,
  type Result,
  type ResultOkRef,
  Success,
  watchRequest,
} from "../api";
import { PaginatedSchema, type Paginated } from "../schemas/paginated";
import {
  AuditClearResponseSchema,
  AuditEntrySchema,
  AuditStatsSchema,
  type AuditClearResponse,
  type AuditEntry,
  type AuditStats,
} from "../schemas/audit";

class AuditLogApi {
  private readonly url = "/audit-entries/";

  getEntries(
    queryParams?: QueryParams,
  ): ResultOkRef<Success<Paginated<AuditEntry[]>>> {
    return watchRequest(
      this.url,
      PaginatedSchema(AuditEntrySchema),
      queryParams,
    );
  }

  getStats(): ResultOkRef<Success<AuditStats>> {
    return watchRequest(`${this.url}stats/`, AuditStatsSchema);
  }

  exportCsv(queryParams?: QueryParams) {
    return api.getBlob(`${this.url}export/`, queryParams);
  }

  clear(): Promise<Result<AuditClearResponse>> {
    return api.post(
      `${this.url}clear/`,
      AuditClearResponseSchema,
      { confirmation: "CLEAR" },
    );
  }
}

const store = defineStore("audit-log", () => ({
  api: markRaw(new AuditLogApi()),
}));

export function useAuditLog() {
  return store().api;
}
